/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import LabelledField from "components/labelled-field";
import useStyles from "cms/fields/_styles";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";
import { DisplaySettingsWrapper } from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
// import useThrottle from 'hooks/useThrottle'
import { Fragment, useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";

const EmbedBuilderFieldItemEdit = () => {
    
    const { t } = useTranslation();
    // const throttler = useThrottle()
    const classes = useStyles();

    const { field } = useCurrentDynamicField();

    const ctx = useContext(ListItemContext);
    const { index, value, settings, updateListItem } = ctx;
    const { name } = field || {};
    
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { noOverride } = schemaSettings || {};
    // schemaSettings: styleOptions, defaultStyle, placeholder, noOverride, defaultValue, formatOptions, required, options: schemaOptions, hidden,
    
    const initialState = {
        value: value ? value : "",
        settings
    };
    const [itemLocalState, setItemLocalState] = useState(initialState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 1200),
        [updateListItem]
    );
    const onChange = (event) => {
        const newValue = event.target.value;
        const newState = { ...itemLocalState, value: newValue };
        setItemLocalState(newState);
        update(newState, index);
    };

    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <div className='simplicity-composer-field-primary'>
                    {/*<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>*/}
                    {itemLocalState?.value ? (
                        <iframe
                            width='100%'
                            height='275px'
                            src={itemLocalState?.value}
                            title={t("commons.embedUrl")}
                            frameBorder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                            allowFullScreen
                        ></iframe>
                    ) : (
                        <div spacing={4} className={classes.defaultEmbedDiv}>
                            <div className='preview'>{t("commons.preview")}</div>
                        </div>
                    )}
                    {/*</Grid>*/}
                </div>
                <DisplaySettingsWrapper>
                    <LabelledField label={t("commons.embedUrl")} className='labelField'>
                        <TextField
                            fullWidth={true}
                            placeholder={t("commons.embedUrl")}
                            value={itemLocalState?.value}
                            disabled={noOverride}
                            variant='standard'
                            onChange={onChange}
                        />
                    </LabelledField>
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
export default EmbedBuilderFieldItemEdit;
